module.exports = __webpack_public_path__ + "static/img/header-backImg.52a7ff9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-backImg.png
// module id = 2gkV
// module chunks = 18